import { Grid } from '@mantine/core'
import { Campaign, Objective, ObjectiveResult } from '@ospace/schemas'
import { Metrics } from '@ospace/shared'
import { ErrorMessage, Field, Form } from 'formik'
import React from 'react'
import { Link } from 'react-router-dom'

type CampaignObjectiveFieldProps = {
  title: string
  text: string
  fieldName: keyof Objective
  totalFieldName: keyof ObjectiveResult
  toggleFieldName: keyof Objective
  objective: Objective
  disabled?: boolean
}

const CampaignObjectiveField = (props: CampaignObjectiveFieldProps) =>
  props.objective[props.toggleFieldName] ? (
    <Grid className='mb-10'>
      <Grid.Col span={4}>
        <span className='fw-bolder fs-6'>{props.title}</span>
        <br></br>
        {props.disabled ? <span className='text-warning'>Automated field</span> : <></>}
      </Grid.Col>
      <Grid.Col span={4}>
        <Field
          type='number'
          className='form-control form-control-lg form-control-solid'
          name={props.fieldName}
          placeholder=''
          min={0}
          disabled={props.disabled || false}
        />
        <span>Number of {props.text} in specified time period</span>
        <div className='text-danger mt-2'>
          <ErrorMessage name={props.fieldName} />
        </div>
      </Grid.Col>
      <Grid.Col span={4}>
        <Field
          name={props.totalFieldName}
          type='number'
          className='form-control form-control-lg form-control-solid'
          min={0}
          placeholder=''
        />
        <span>Total {props.text} since start of campaign</span>
        <div className='text-danger mt-2'>
          <ErrorMessage name={props.totalFieldName} />
        </div>
      </Grid.Col>
    </Grid>
  ) : null

const ObjectiveForm: React.FC<{
  mutation: any
  campaign: Campaign
  backLink: any
}> = (props) => {
  const { mutation, campaign, backLink } = props
  return (
    <Form className='form' noValidate>
      <div className='card-content'>
        <div className='card-body py-lg-10 px-lg-10'>
          <div className='row  mb-10'>
            <div className='col-md-6 fv-row'>
              <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                <span className='required'>Start date</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify start date of the campaign'
                ></i>
              </label>

              <Field
                type='date'
                className='form-control form-control-lg form-control-solid'
                name='startDate'
                placeholder=''
              />
              <div className='text-danger mt-2'>
                <ErrorMessage name='startDate' />
              </div>
            </div>
            <div className='col-md-6 fv-row'>
              <label className='d-flex align-items-center fs-5 fw-bold mb-2'>
                <span>End date</span>
                <i
                  className='fas fa-exclamation-circle ms-2 fs-7'
                  data-bs-toggle='tooltip'
                  title='Specify end date of the campaign'
                ></i>
              </label>

              <Field
                type='date'
                className='form-control form-control-lg form-control-solid'
                name='endDate'
                placeholder=''
              />
              <div className='text-danger mt-2'>
                <ErrorMessage name='endDate' />
              </div>
            </div>
          </div>

          {!!campaign.objective?.isDigitalProspectingActive && (
            <div className='fv-row'>
              <h2 className='mt-20 mb-10'>Digital Prospecting</h2>
              <CampaignObjectiveField
                objective={campaign.objective}
                title={Metrics.impressions}
                text='impressions'
                fieldName='impressions'
                totalFieldName='totalImpressions'
                toggleFieldName='isImpressionsEnabled'
              />
              <CampaignObjectiveField
                objective={campaign.objective}
                title={Metrics.campaignClicks}
                text='campaign clicks'
                fieldName='campaignClicks'
                totalFieldName='totalCampaignClicks'
                toggleFieldName='isCampaignClicksEnabled'
              />
            </div>
          )}
          <button type='submit' className='btn btn-primary' disabled={mutation.isLoading}>
            {!!mutation.isLoading && (
              <span className='spinner-border spinner-border-sm align-middle mx-2' />
            )}
            Submit
          </button>
          <Link to={backLink} className='btn btn-secondary m-10'>
            Cancel
          </Link>
        </div>
      </div>
    </Form>
  )
}

export { ObjectiveForm }
